function PersonalizeraiWait() {
  try {
    let intervalId;
    let timeoutId;

    intervalId = setInterval(() => {
      try {
        if (
          typeof window.PersonalizerAI !== "undefined" ||
          window.Shopify?.designMode
        ) {
          console.info("Personalizerai Embed Loaded!");

          helperFunctionsInit();

          console.info("Personalizerai Helper function initialized!");
          console.info("Starting Widget Rendering.....");

          const templateName =
            window?.PersonalizerAI?.trackingData?.templateName || "";

          if (templateName === "product") {
            new PersonalizeraiUpsellRenderer();
          } else if (templateName === "cart") {
            new PersonalizeraiUpsellCartRenderer("cart");
          }

          new PersonalizeraiUpsellCartRenderer("cart-drawer");
          new PersonalizeraiCustomCard();
          new PersonalizeraiTabbedCard();

          clearInterval(intervalId);
          clearTimeout(timeoutId);
        }
      } catch (err) {
        console.error(err);
        clearInterval(intervalId);
        clearTimeout(timeoutId);
      }
    }, 10);

    timeoutId = setTimeout(() => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
      console.info("PersonalizerAI Embed not loaded!!");
      console.info("Widget could not be loaded");
    }, 10000);
  } catch (err) {
    console.error(err);
  }
}

async function RemoveLoading() {
  let timer = setTimeout(() => {
    const loadingDivs = document.querySelectorAll(
      ".personalizerai__loading-skeleton"
    );

    if (!loadingDivs.length) {
      return;
    }

    console.log("Loading divs found.");
    console.log("Removing loading divs...");

    loadingDivs.forEach((div) => div.remove());
    clearTimeout(timer);

    console.log("Removed Loading divs");
  }, 5000);
}

personalizeraiGridSliderInit();
PersonalizeraiWait();
RemoveLoading();

function helperFunctionsInit() {
  // variables
  const VISITOR_COOKIE_NAME = "personalizerai-visitor-id";
  const DATA_ID = "_personalizerai_tracking";
  const API_URL = "https://predict.personalizerai.com";
  const TRACK_API_URL = "https://us.personalizerai.com";

  function getVisitorId() {
    if (window.Shopify.designMode) return null;

    let visitorId = window.localStorage.getItem(VISITOR_COOKIE_NAME);
    if (!visitorId) {
      visitorId = document.cookie
        .split("; ")
        .map((cookie) => cookie.split("="))
        .filter((cookie) => cookie[0] === "_shopify_y")?.[0]?.[1];

      //! it might be that cookie does not exists
      if (visitorId)
        window.localStorage.setItem(VISITOR_COOKIE_NAME, visitorId);
    }

    return visitorId;
  }

  window.PersonalizerAI.sdk = {};
  window.PersonalizerAI.sdk.removeGID = function (id, type) {
    if (!id) throw new Error("Id not found");
    return (
      id.split(`gid://shopify/${type}/`)[0] ||
      id.split(`gid://shopify/${type}/`)[1]
    );
  };

  window.PersonalizerAI.sdk.sendWidgetViewEvent = async function ({
    products,
    attributionToken,
    settings
  }) {
    try {
      let customerId = undefined;
      const templateName = window[DATA_ID]?.templateName;
      if (window[DATA_ID]?.customerId) {
        customerId = window[DATA_ID]?.customerId.toString();
      }
      const event = {
        type: "WIDGET_VIEW",
        shop: window.Shopify.shop,
        visitorId: getVisitorId(),
        customerId,
        products,
        collection:
          templateName === "collection"
            ? {
                id: window[DATA_ID]?.collectionId || undefined,
                title: window[DATA_ID]?.collectionTitle || undefined,
              }
            : undefined,
        url: window.document.location.href,
        pageDetails: {
          template: window[DATA_ID]?.templateName || undefined,
          referrer: document.referrer,
          title: document.title,
          characterSet: document.characterSet,
          location: {
            href: window.location.href,
            hash: window.location.hash,
            host: window.location.host,
            hostname: window.location.hostname,
            origin: window.location.origin,
            pathname: window.location.pathname,
            port: window.location.port,
            protocol: window.location.protocol,
            search: window.location.search
          },
        },
        visitorDetails: {
          firstName: window[DATA_ID]?.customerFirstName || undefined,
          lastName: window[DATA_ID]?.customerLastName || undefined,
          email: window[DATA_ID]?.customerEmail || undefined,
          phone: window[DATA_ID]?.customerPhone || undefined,
          userAgent: navigator.userAgent,
          language: navigator.language,
          languages: navigator.languages,
          screen: {
            height: window.screen.height,
            width: window.screen.width
          },
          innerHeight: window.innerHeight,
          innerWidth: window.innerWidth,
          outerHeight: window.outerHeight,
          outerWidth: window.outerWidth,
        },
        timestamp: new Date().toISOString(),
        attributionToken,
        meta: {
          modelId: settings.modelId,
          limit: settings.limit,
          widgetId: settings.widgetId,
        }
      };


      await fetch(TRACK_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(event),
      });
    } catch (err) {
      console.error("Unable to send widget view event!", err);
    }
  };

  window.PersonalizerAI.sdk.supportedReviewAppsData = {
    none: {
      namespace: "reviews",
      numberOfReviews: "rating_count",
      averageRating: "rating",
    },
    judgeme: {
      namespace: "reviews",
      numberOfReviews: "rating_count",
      averageRating: "rating",
    },
    loox: {
      namespace: "loox",
      numberOfReviews: "num_reviews",
      averageRating: "avg_rating",
    },
    fera: {
      namespace: "reviews",
      numberOfReviews: "rating_count",
      averageRating: "rating",
    },
    okendo: {
      namespace: "reviews",
      numberOfReviews: "rating_count",
      averageRating: "rating",
    },
    opinew: {
      namespace: "opinew_metafields",
      numberOfReviews: "reviews_count",
      averageRating: "reviews_average",
    },
    stamped: {
      namespace: "reviews",
      numberOfReviews: "rating_count",
      averageRating: "rating",
    },
  };

  window.PersonalizerAI.sdk.getReviewAppAverageRating = function (
    reviewApp,
    rating
  ) {
    switch (reviewApp) {
      case "none":
      case "stamped":
      case "okendo":
      case "fera":
      case "judgeme":
        return rating?.value ? parseInt(JSON.parse(rating?.value).value) : 0;
      case "opinew":
      case "loox":
        return parseInt(rating);
    }
  };

  window.PersonalizerAI.sdk.getGlobalProductId = function (id) {
    const idArr = id.toString().split("gid://shopify/Product/");
    if (idArr.length === 1) {
      return `gid://shopify/Product/${id}`;
    } else {
      return id.toString();
    }
  };

  window.PersonalizerAI.sdk.fetchPredictions = async function ({
    blockId,
    shop,
    test,
    modelId,
    limit,
    meta,
    contextCart,
  }) {
    if (!(DATA_ID in window)) return null;
    const data = window[DATA_ID];

    let currentProductIds = [];

    if (contextCart) {
      currentProductIds = data?.cartItems?.length
        ? data?.cartItems.map((item) => `${item?.product_id}`)
        : [];
    }

    const body = {
      visitorId: getVisitorId(),
      customerId: data?.customerId ? `${data.customerId}` : undefined,
      currentProductId: data?.productId ? `${data?.productId}` : undefined,
      currentProductIds,
      cartProductIds: data?.cartItems?.length
        ? data?.cartItems.map((item) => `${item?.product_id}`)
        : [],
      collectionId: data?.collectionId
        ? `gid://shopify/Collection/${data.collectionId}`
        : undefined,
      widgetId: blockId,
      meta,
    };

    // get dummy predictions while in theme design mode
    const queryParams = `shop=${shop}&modelId=${modelId}&limit=${limit}&test=${test}`;

    const response = await fetch(
      `https://predict.personalizerai.com?${queryParams}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...body,
        }),
      }
    );

    if (!response.ok)
      return response.json().then((response) => {
        throw new Error(response.message);
      });
    const prediction = await response.json();
    return {
      products: prediction.recommendedProductIds,
      attributionToken: prediction.attributionToken,
    };
  };

  window.PersonalizerAI.sdk.fetchProducts = async function (ids) {
    const currentCountry = window.Shopify.country || "US";
    const currentLanguage =
      window.Shopify?.locale?.replace("-", "_")?.toUpperCase() || "EN";
    const globalIds = ids.map((id) =>
      window.PersonalizerAI.sdk.getGlobalProductId(id)
    );
    const dpr = Math.floor(
      window.devicePixelRatio >= 1 ? window.devicePixelRatio : 1
    );
    // change this according to the no of columns
    const imageMaxWidth = window.innerWidth || 500;
    const reviewApp = window.PersonalizerAI.sdk.supportedReviewAppsData["none"];

    const response = await fetch(
      `https://${window.Shopify.shop}/api/2024-04/graphql.json`,
      {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            window.PersonalizerAI.storefrontAccessToken,
        },
        body: JSON.stringify({
          query: `
          query Product( $namespace: String!,$numberOfReviews: String!,$averageRating: String!)  @inContext(country: ${currentCountry},language: ${currentLanguage}){	
            nodes(ids:[${globalIds.map((id) => `"${id}"`)}]) {
              ... on Product {
              id
              vendor
              handle
              onlineStoreUrl
              availableForSale
              title
              options(first:100) {
                    id
                    name
                    values
                }
              compareAtPriceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
                  maxVariantPrice {
                  amount
                  currencyCode
                }
              }
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
                  maxVariantPrice {
                  amount
                  currencyCode
                }
              }
              images(first:2) {
                nodes {
                    url 
                    altText
                    height
                    width
                }
            }
              
              priceRange {
                maxVariantPrice {
                  amount 
                  currencyCode
                }
              }
              rating: metafield(namespace: $namespace, key: $averageRating) {
                value
              }
              rating_count: metafield(namespace: $namespace, key: $numberOfReviews) {
                value
              }
              variants(first:100) {
                nodes {
                  id
                  availableForSale
                  title
                  image {
                    url(transform: {maxWidth:${imageMaxWidth},scale: ${dpr}}) 
                    altText
                  }
                   selectedOptions {
                        name
                        value
                    }
                  compareAtPrice {
                    amount 
                    currencyCode
                  }
                  price {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        }
      `,
          variables: {
            namespace: reviewApp.namespace,
            averageRating: reviewApp.averageRating,
            numberOfReviews: reviewApp.numberOfReviews,
          },
        }),
      }
    );

    const data = await response.json();
    return data.data.nodes
      .filter((node) => node !== null)
      .map((node) => ({
        ...node,
        rating_count: {
          value: node?.rating_count?.value
            ? Math.round(node?.rating_count?.value)
            : 0,
        },
        rating: {
          value:
            node && node?.rating
              ? window.PersonalizerAI.sdk.getReviewAppAverageRating(
                  this.reviewApp,
                  node.rating
                )
              : 0,
        },
      }));
  };

  window.PersonalizerAI.sdk.formatCurrency = function (price) {
    const locale =
      window?.Shopify?.locale && window?.Shopify?.locale.split("-").length >= 2
        ? window?.Shopify?.locale
        : window?.Shopify?.locale && window?.Shopify?.country
        ? `${window.Shopify.locale}-${window.Shopify.country}`
        : undefined;

    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: price.currencyCode,
    }).format(parseFloat(price.amount));
  };

  window.PersonalizerAI.sdk.getDisplayPrice = function (product) {
    let priceToShow = {
      price: "",
      compareAtPrice: "",
    };

    let minPrice = parseFloat(product?.priceRange?.minVariantPrice?.amount);
    let maxPrice = parseFloat(product?.priceRange?.maxVariantPrice?.amount);
    let minCompareAtPrice = parseFloat(
      product?.compareAtPriceRange?.minVariantPrice?.amount || 0
    );
    let maxCompareAtPrice = parseFloat(
      product?.compareAtPriceRange?.maxVariantPrice?.amount || 0
    );
    let price = {
      amount: minPrice,
      currencyCode: product?.priceRange?.minVariantPrice?.currencyCode || "US",
    };

    let compareAtPrice = {
      amount: minCompareAtPrice,
      currencyCode: product?.priceRange?.minVariantPrice?.currencyCode || "US",
    };

    if (!minCompareAtPrice) {
      if (minPrice === maxPrice) {
        priceToShow.price = window.PersonalizerAI.sdk.formatCurrency(price);
      } else {
        priceToShow.price = `From ${window.PersonalizerAI.sdk.formatCurrency(
          price
        )}`;
      }
    } else if (minPrice < minCompareAtPrice) {
      if (minPrice === maxPrice) {
        priceToShow.price = window.PersonalizerAI.sdk.formatCurrency(price);
      } else {
        priceToShow.price = `From ${window.PersonalizerAI.sdk.formatCurrency(
          price
        )}`;
      }
      priceToShow.compareAtPrice =
        window.PersonalizerAI.sdk.formatCurrency(compareAtPrice);
    } else {
      if (minPrice === maxPrice) {
        priceToShow.price = window.PersonalizerAI.sdk.formatCurrency(price);
      } else {
        priceToShow.price = `From ${window.PersonalizerAI.sdk.formatCurrency(
          price
        )}`;
      }
    }

    return priceToShow;
  };

  __personalizeraiOnDialogCloseRemoveAttributionTokenData();
  window.PersonalizerAI.sdk.loaded = true;
  console.info("Personalizerai SDK Loaded");
}

class PersonalizeraiUpsellCartRenderer {
  constructor(type) {
    this.type = type;
    const widgets = [
      ...document.querySelectorAll(`.personalizerai__widget--${this.type}`),
    ];

    if (widgets.length) {
      this.renderWidgets(widgets);
    } else {
      console.info(`No ${type} widget target found to render`);
    }
  }

  renderWidgets(widgets) {
    for (const widget of widgets) {
      this.renderWidget(widget);
    }
  }

  async renderWidget(widget) {
    try {
      const type = this.type;
      const widgetType = widget?.dataset?.type || "cart-drawer";
      const settings = {
        shop: window.PersonalizerAI.shop,
        modelId: widget.dataset?.model || "recently_viewed",
        limit: 3,
        dummy: window.Shopify?.designMode || false,
        template: "cart",
        widgetType: "card",
      };

      const blockId = `personalizerai-widget__cart--${widgetType}--${settings.modelId}`;

      const prediction = await window.PersonalizerAI.sdk.fetchPredictions({
        shop: settings.shop,
        modelId: settings.modelId,
        limit: settings.limit,
        test: settings.dummy,
        meta: {},
        blockId,
        contextCart: true,
      });

      if (!prediction?.products?.length) return;

      let products = await window.PersonalizerAI.sdk.fetchProducts(
        prediction.products
      );

      if (!products?.filter((p) => p)?.length) return;
      products = products.filter((p) => p);

      try {
        window.PersonalizerAI.sdk.sendWidgetViewEvent({
          products: products.map((prod) => ({
            productId: window.PersonalizerAI.sdk.removeGID(prod.id, "Product"),
            variantId: window.PersonalizerAI.sdk.removeGID(prod.id, "Product"),
            quantity: 1,
          })),
          attributionToken:prediction.attributionToken,
          settings: {
            limit: settings.limit,
          modelId: settings.modelId,
          widgetId: blockId, 
          }
        });
      } catch (err) {
        console.log(err, "unable to send event");
      }

      const productsHTML = products.map((product) => {
        return new PersonalizeraiCustomVerticalCard(
          {
            ...product,
            displayPrice: window.PersonalizerAI.sdk.getDisplayPrice(product),
          },
          prediction.attributionToken,
          `data-personalizerai-${widgetType}`
        ).html();
      });

      widget.innerHTML = `
        <div class="personalizerai__widget--${type}__wrapper">
          <div class="drawer__items-title">${settings.modelId
            .toUpperCase()
            .replace("_", " ")}</div>
          ${productsHTML.join("")}
        </div>
        `;

      __personalizeraiOnRecommendationAddSetAttributionTokenDataOnDialog(
        `.personalizerai__widget--${type} .btn__outer button`
      );
    } catch (err) {
      console.error(err);
      widget.innerHTML = "";
    }
  }
}

class PersonalizeraiUpsellRenderer {
  constructor() {
    const target = document.querySelector(".personalizerai__widget-ctl");
    if (target) {
      this.renderWidget(target);
    } else {
      console.info("No Complete the look target found");
    }
  }

  async renderWidget(target) {
    try {
      const settings = {
        shop: window.PersonalizerAI.shop,
        modelId: "complete_the_look",
        limit: 4,
        dummy: window.Shopify?.designMode || false,
        template: "product",
        widgetType: "card",
      };

      // add required meta for CompleteTheLook model
      // Add the current products product type
      const productType = target.dataset.type; // string | null
      // Add the current products tags
      const tags = target.dataset.tags; // string | null

      // fetch prediction
      const prediction = await window.PersonalizerAI.sdk.fetchPredictions({
        shop: settings.shop,
        modelId: settings.modelId,
        limit: settings.limit,
        test: settings.dummy,
        meta: {
          productType,
          tags,
        },
        blockId: `personalizerai-widget__complete-the-look`,
      });

      if (!prediction?.products?.length) return;

      // fetch products from prediction
      let products = await window.PersonalizerAI.sdk.fetchProducts(
        prediction.products
      );

      if (!products?.filter((p) => p)?.length) return;
      products = products.filter((p) => p);

      // sending widget view event 
      try {
        window.PersonalizerAI.sdk.sendWidgetViewEvent({
          products: products.map((prod) => ({
            productId: window.PersonalizerAI.sdk.removeGID(prod.id, "Product"),
            variantId: window.PersonalizerAI.sdk.removeGID(prod.id, "Product"),
            quantity: 1,
          })),
          attributionToken:prediction.attributionToken,
          settings: {
            limit: settings.limit,
            modelId: settings.modelId,
            widgetId: `personalizerai-widget__complete-the-look`
          }
        });
      } catch (err) {
        console.error(err, "unable to send event");
      }

      // initialize quick-add-product widget with products
      const productsHTML = products.map((product) => {
        return new PersonalizeraiCustomVerticalCard(
          {
            ...product,
            displayPrice: window.PersonalizerAI.sdk.getDisplayPrice(product),
          },
          prediction.attributionToken,
          "data-personalizerai-complete-the-look"
        ).html();
      });

      target.setAttribute(
        "data-attribution-token",
        prediction.attributionToken
      );
      target.innerHTML = `
        <div class="product__block product__upsell block-padding" style="--block-padding-bottom: 16px;">
          <p class="product-upsell__holder__title">GOES WELL WITH:</p>
          ${productsHTML.join("")}
        </div>
        `;
      __personalizeraiOnRecommendationAddSetAttributionTokenDataOnDialog(
        ".personalizerai__widget-ctl .btn__outer button"
      );
    } catch (err) {
      console.error(err);

      target.innerHTML = "";
    }
  }
}

class PersonalizeraiCustomVerticalCard {
  constructor(product, attributionToken, analyticsTag) {
    this.product = product;
    this.attributionToken = attributionToken;
    this.analyticsTag = analyticsTag;
  }

  html() {
    const product = this.product;
    const attributionToken = this.attributionToken;
    const analyticsTag = this.analyticsTag;

    const productId = product.id.split("gid://shopify/Product/")[1] ?? "";
    const productHandle = product?.handle ?? "";
    const productUrl = `/products/${productHandle}?personalizerai_attr_token=${attributionToken}`;
    const shopifyCdnImageUrl = product.images.nodes[0].url;
    const imageSlug = shopifyCdnImageUrl
      .split("/")
      [shopifyCdnImageUrl.split("/").length - 1].split("?")[0];
    const imageUrl = `//www.hatcountry.com/cdn/shop/files/${imageSlug}`;

    return `
      <quick-add-product>
        <div
          class="product-upsell__holder product-upsell__holder--button"
          data-quick-add-holder=${productId}
        >
          <div
            data-cart-errors-container=""
            class="product-upsell__errors"
          ></div>

          <div class="product-upsell">
            <div class="product-upsell__image">
              <a
                href=${productUrl}
                class="product-upsell__image__link"
                aria-label=${product.title}
              >
                <div class="product-upsell__image__thumb">
                  <figure
                    class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill"
                    style="--aspect-ratio: 0.7"
                  >
                    <img
                      src="${imageUrl}?crop=center&height=342&v=1723661418&width=240"
                      alt="${product.title}"
                      width="240"
                      height="342"
                      loading="eager"
                      srcset="
                  ${imageUrl}?width=120 120w,
                  ${imageUrl}?width=180 180w,
                  ${imageUrl}?width=240 240w,
                  ${imageUrl}?width=300 300w,
                  ${imageUrl}?width=360 360w,
                  ${imageUrl}?width=840 840w
                "
                       sizes="120px"
                      class=""
                    />
                  </figure>
                </div>
              </a>
            </div>

            <div class="product-upsell__content">
              <a href=${productUrl} class="product-upsell__link">
                <p class="product-upsell__title h3">${product.title}</p>
                <p class="personalizerai__widget__price-box">
                <span class="personalizerai__widget__price-box--new-price">${
                  product.displayPrice.price
                }</span>
                  ${
                    product.displayPrice.compareAtPrice
                      ? `
                    <span class="personalizerai__widget__price-box--old-price">${product.displayPrice.compareAtPrice}</span>
              `
                      : ""
                  }
                  
                </p>
              </a>
              <div class="product-upsell__actions">
                <div class="btn__outer">
                  <button
                    class="product-upsell__btn"
                    type="button"
                    data-quick-add-btn=""
                    data-personalizerai-attribution-token="${attributionToken}"
                    data-product-id="${productId}"
                    data-quick-add-modal-handle=${productHandle}
                  >
                    <span class="btn__plus"></span>
                    <span class="btn__text">Add</span>

                    <span class="btn__loader">
                      <svg height="18" width="18" class="svg-loader">
                        <circle r="7" cx="9" cy="9"></circle>
                        <circle
                          stroke-dasharray="87.96459430051421 87.96459430051421"
                          r="7"
                          cx="9"
                          cy="9"
                        ></circle>
                      </svg>
                    </span>

                    <span class="btn__added">&nbsp;</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <template data-quick-add-modal-template="">
            <dialog
              ${analyticsTag}='true'
              class="drawer product-quick-add"
              data-product-id="${productId}"
              data-section-id="${analyticsTag}"
              inert=""
              data-quick-add-modal=""
              data-scroll-lock-required=""
            >
              <form method="dialog">
                <button
                  class="visually-hidden no-js"
                  aria-label="Close"
                ></button>
              </form>

              <div
                class="drawer__inner product-quick-add__content"
                data-product-upsell-container=""
                data-scroll-lock-scrollable=""
                style="--swatch-size: var(--swatch-size-product)"
              >
                <div class="product-quick-add__close-outer">
                  <button
                    class="product-quick-add__close drawer__close"
                    aria-label="Close"
                    data-quick-add-modal-close=""
                    autofocus=""
                  >
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      class="icon icon-cancel"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M6.758 17.243 12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </button>
                </div>

                <div
                  class="product-quick-add__inner"
                  data-product-upsell-ajax=""
                ></div>

                <div class="loader loader--top">
                  <div class="loader-indeterminate"></div>
                </div>
              </div>
            </dialog>
          </template>
        </div>
        </quick-add-product>
      `;
  }
}

class PersonalizeraiCustomCard {
  constructor() {
    this.widgets = [
      ...document.querySelectorAll("[data-personalizerai-widget]"),
    ];
    if (this.widgets?.length) {
      this.renderWidgets(this.widgets);
    } else {
      console.info("No widget target found for Custom card to render");
    }
  }

  renderWidgets(widgets) {
    for (const widget of widgets) {
      this.renderWidget(widget);
    }
  }

  async renderWidget(widget) {
    try {
      const widgetSettings = this.generateWidgetSettings(widget);
      const predictions = await this.getPredictions(widget, widgetSettings);
      if (!predictions?.products?.length) return;

      let products = await this.getProducts(predictions);

      if (!products?.filter((p) => p)?.length) return;
      products = products?.filter((p) => p);

      widgetSettings.attributionToken = predictions.attributionToken;
      try {
        window.PersonalizerAI.sdk.sendWidgetViewEvent({
          products: products.map((prod) => ({
            productId: window.PersonalizerAI.sdk.removeGID(prod.id, "Product"),
            variantId: window.PersonalizerAI.sdk.removeGID(prod.id, "Product"),
            quantity: 1,
          })),
          attributionToken:predictions.attributionToken,
          settings: {
            modelId: widgetSettings.model,
          limit: widgetSettings.limit, 
          widgetId: widgetSettings.sectionId,
          }
        });
      } catch (err) {
        console.log(err, "unable to send event");
      }
      widget.innerHTML = this.Products(products, widgetSettings);

      // ! attribution token for gridswatches;
      this.gridSwatchAttributionTokenInjector(widget);
      // quick add button attribution token injector
      __personalizeraiOnRecommendationAddSetAttributionTokenDataOnDialog(
        ".personalizerai__widget__custom_card .quick-add__holder .quick-add__button"
      );
    } catch (err) {
      console.error(err);
      widget.innerHTML = "";
    }
  }

  generateWidgetSettings(widget) {
    return {
      model: widget?.dataset?.model || "recently_viewed",
      ...JSON.parse(widget?.dataset?.settings || "{}"),
      sectionId: widget.dataset.sectionId || "",
    };
  }

  async getPredictions(widget, widgetSettings) {
    const settings = {
      shop: window.PersonalizerAI.shop,
      modelId: widgetSettings?.model || "recently_viewed",
      limit: widgetSettings?.limit || 4,
      dummy: window?.Shopify?.designMode ?? false,
      template: window.PersonalizerAI.trackingData.templateName,
      widgetType: "card",
    };

    const prediction = await window.PersonalizerAI.sdk.fetchPredictions({
      shop: settings.shop,
      modelId: settings.modelId,
      limit: settings.limit,
      test: settings.dummy,
      meta: {},
      blockId: widgetSettings.sectionId,
    });

    return prediction;
  }

  async getProducts(prediction) {
    const products = await window.PersonalizerAI.sdk.fetchProducts([
      ...prediction?.products,
    ]);

    let mutatedProducts = products.map((product) => {
      let displayPrice = window.PersonalizerAI.sdk.getDisplayPrice(product);
      const productUrl = `${
        product.onlineStoreUrl?.split("?")[0]
      }?personalizerai_attr_token=${prediction.attributionToken}`;
      const colorOptions = product.options.find(
        (option) => option.name === "Color" && option.values.length >= 1
      );
      const attributionToken = prediction.attributionToken;
      const productId = product.id.split("gid://shopify/Product/")[1];

      const colorVariants = {};

      if (colorOptions) {
        colorOptions.values.forEach((value) => {
          const variant = product.variants.nodes.find((variant) =>
            variant.title.includes(value)
          );
          if (variant) {
            colorVariants[value] = variant;
          }
        });
      }

      return {
        ...product,
        displayPrice,
        productUrl,
        colorOptions,
        attributionToken,
        colorVariants,
        productId,
      };
    });

    return mutatedProducts;
  }

  async gridSwatchAttributionTokenInjector(widget) {
    const widgets = [...widget.querySelectorAll("grid-swatch")];

    if (!widgets.length) return;

    const observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (
          mutation.target.nodeName === "GRID-SWATCH" &&
          mutation.addedNodes.length
        ) {
          const attributionToken =
            mutation?.target?.dataset?.personalizeraiAttributionToken;

          if (!attributionToken) return;
          const anchors = [...mutation.target.querySelectorAll("a")];
          anchors.forEach((a) => {
            const searchParam = new URLSearchParams(a.href.split("?")[1]);
            if (searchParam.get("personalizerai_attr_token")) return;

            searchParam.append("personalizerai_attr_token", attributionToken);
            a.href = `${a.href.split("?")[0]}?${searchParam.toString()}`;
          });
        }
      }
    });

    widgets.forEach((widget) => {
      observer.observe(widget, { childList: true });
    });
  }

  // ui elements

  Products(products, widgetSettings) {
    const ProductCardWidget = this.ProductCard.bind(this);
    return `
  <div class="personalizerai-product-recommendations">
         <h3 class="personalizerai-block__heading heading-size-5" >
          ${widgetSettings?.heading || ""}
          </h3>
        <div style="--column-count: 6.5; --COLUMNS-SMALL: 2; --COLUMNS-MOBILE: 2;">
          <div class="grid-outer">

      
        
          <pai-grid-slider
              align-arrows=""
            >
          
               <div
                  class="grid grid--slider ${
                    parseInt(widgetSettings.limit) <= 4 || products?.length <= 4
                      ? "grid--slider--large-card"
                      : ""
                  } is-enabled scroll-snap-disabled grid--mobile-slider"
                  data-grid-slider=""
                  data-slides-to-move='3'
                  id="product-recommendations-personalizerai"
                >
            
                ${products
                  .map((product) => ProductCardWidget(product, widgetSettings))
                  .join("")}
                </div>
            
            </pai-grid-slider>
        
        </div>
      </div>
  </div>
  `;
  }

  ProductCard(product, widgetSettings) {
    const ProductImage = this.ProductImage.bind(this);
    const ProductInformation = this.ProductInformation.bind(this);
    return `
    <div
      class="grid-item product-item product-item--swatches product-item--centered product-item--outer-text product-item--has-quickbuy"
    id="product-item--${widgetSettings.sectionId}-${
      product.id.split("gid://shopify/Product/")[1]
    }"
      style="--swatch-size: var(--swatch-size-filters)"
      data-grid-item=""
      >

      ${ProductImage(product, widgetSettings)}
      ${ProductInformation(product, widgetSettings)}

  </div>
    
    `;
  }

  ProductInformation(product, widgetSettings) {
    const productURL = `${product.onlineStoreUrl}?personalizerai_attr_token=${widgetSettings.attributionToken}`;
    const colorOptions = product.options.find(
      (option) => option.name === "Color" && option.values.length >= 1
    );

    const colorVariants = {};

    if (colorOptions) {
      colorOptions.values.forEach((value) => {
        const variant = product.variants.nodes.find((variant) =>
          variant.title.includes(value)
        );
        if (variant) {
          colorVariants[value] = variant;
        }
      });
    }

    return `
  <div class="product-information" data-product-information="">
  <div class="product-item__info">
   <a
        class="product-link"
        href=${productURL}
        data-product-link=${productURL}
      >
        <p class="product-item__title">${product.title}</p>

        <div class="product-item__price__holder">
          <div class="product-item__price">
            <span class="personalizerai__widget__price-box">
              <span class="personalizerai__widget__price-box--new-price">${
                product.displayPrice.price
              }</span>
              ${
                product.displayPrice.compareAtPrice
                  ? `
                <span class="personalizerai__widget__price-box--old-price">${product.displayPrice.compareAtPrice}</span>
              `
                  : ""
              }
            </span>
          </div>
        </div>
      </a>

      <div
        class="product-item__swatches__holder product-item__swatches__holder--square product-item__swatches__holder--text-slider"
      >

       <form
          class="radio__fieldset radio__fieldset--swatches radio__fieldset--pgi"
          data-grid-swatch-form=""
          data-fieldset=""
        >

        ${
          colorOptions
            ? `
        

        <grid-swatch
            class="selector-wrapper__scrollbar"
            data-scrollbar=""
            data-personalizerai-attribution-token="${
              widgetSettings.attributionToken
            }"
            data-swatch-handle=${product.handle}
            data-swatch-label="Color"
            data-swatch-values="${colorOptions.values
              .map((key) => `${key}:${key.toLowerCase().replaceAll(" ", "-")}`)
              .join(",")}"
          >         
          </grid-swatch>
        `
            : ""
        }
          


        <div class="selector-wrapper__actions">
            <button
              type="button"
              class="radio__fieldset__arrow radio__fieldset__arrow--prev is-hidden"
              data-scrollbar-arrow-prev=""
            >
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                class="icon icon-nav-arrow-left"
                viewBox="0 0 24 24"
              >
                <path d="m15 6-6 6 6 6" stroke="#000" stroke-linecap="round"
                stroke-linejoin="round" / >
              </svg>
              <span class="visually-hidden">See All</span>
            </button>
            <button
              type="button"
              class="radio__fieldset__arrow radio__fieldset__arrow--next is-hidden"
              data-scrollbar-arrow-next=""
            >
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                class="icon icon-nav-arrow-right"
                viewBox="0 0 24 24"
              >
                <path
                  d="m9 6 6 6-6 6"
                  stroke="#000"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
              <span class="visually-hidden">See All</span>
            </button>
          </div>
        
        </form>

      

      ${
        colorOptions?.values?.length
          ? `
      <span class="product-item__swatches__count">
          <span data-swatch-count="">${colorOptions.values.length} colors</span>
        </span>
      `
          : ``
      }
       
      </div>
  </div>
  </div>
  
  `;
  }

  ProductImage(product, widgetSettings) {
    const QuickAddProduct = this.QuickAddProduct.bind(this);
    const productURL = `${product.onlineStoreUrl}?personalizerai_attr_token=${widgetSettings.attributionToken}`;
    const shopifyCdnImageUrl = product.images.nodes[0].url;
    const imageSlug = shopifyCdnImageUrl
      .split("/")
      [shopifyCdnImageUrl.split("/").length - 1].split("?")[0];
    const imageUrl = `//www.hatcountry.com/cdn/shop/files/${imageSlug}`;
    const colorOptions = product.options.find(
      (option) => option.name === "Color" && option.values.length >= 1
    );
    const colorVariants = {};

    if (colorOptions) {
      colorOptions.values.forEach((value) => {
        const variant = product.variants.nodes.find((variant) => {
          return variant?.selectedOptions?.find(
            (option) => option.name === "Color" && option.value === value
          );
        });
        if (variant) {
          colorVariants[value] = variant;
        }
      });
    }

    return `
  <div
    class="product-item__image ${
      product?.images?.nodes?.length > 1 ? "double__image" : ""
    }"
    data-product-image=""
  >
  <a
      class="product-link"
      href=${productURL}
      aria-label=${product.title}
      data-product-link=${productURL}
      >

      <div
        class="product-item__bg"
        data-product-image-default=""
      >

      <figure
          class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill"
          style="--aspect-ratio: 1; font-size: 19.2px !important;"
          data-aos="img-in"
          data-aos-delay="200"
          data-aos-duration="800"
          data-aos-anchor="#product-item--${widgetSettings.sectionId}-${
      product.id.split("gid://shopify/Product/")[1]
    }"
          data-aos-easing="ease-out-quart"
          data-asw-orgbgnotimg="none"
        >

        <img
            src=${imageUrl}
            alt=${product.images.nodes[0]?.altText || ""}
           
            loading="eager"
            srcset="
              ${imageUrl}?width=136   136w,
              ${imageUrl}?width=160   160w,
              ${imageUrl}?width=180   180w,
              ${imageUrl}?width=220   220w,
              ${imageUrl}?width=254   254w,
              ${imageUrl}?width=284   284w,
              ${imageUrl}?width=292   292w,
              ${imageUrl}?width=320   320w,
              ${imageUrl}?width=480   480w,
              ${imageUrl}?width=528   528w,
              ${imageUrl}?width=640   640w,
              ${imageUrl}?width=720   720w,
              ${imageUrl}?width=960   960w,
              ${imageUrl}?width=1080 1080w,
              ${imageUrl}?width=1200 1200w
            "
            sizes="(min-width: 1400px) calc((100vw - 288px) / 4), (min-width: 750px) calc((100vw - 258px) / 2), (min-width: 480px) calc(100vw / 2), calc(100vw / 2)"
            fetchpriority="high"
            class=""
            data-asw-orgbgnotimg="none"
            style="font-size: 19.2px !important;"
          />

        </figure>

        ${Object.values(colorVariants)
          .map((variant) => {
            const cdnVariantImageUrl = variant?.image?.url || "";
            const variantImageSlug = cdnVariantImageUrl
              ?.split("/")
              [cdnVariantImageUrl.split("/").length - 1]?.split("?")?.[0];
            const variantImageUrl = variantImageSlug
              ? `//www.hatcountry.com/cdn/shop/files/${variantImageSlug}`
              : "";
            return `
           <div
          class="product-item__bg__inner"
          data-variant-title="${variant.title}"
        >
          <figure
            class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill"
            style="--aspect-ratio: 1"
          >
            <img
              src="${variantImageUrl}?crop=center"
              alt=${variant.image?.altText || ""}
              
              loading="lazy"
              srcset="
                ${variantImageUrl}?width=136   136w,
                ${variantImageUrl}?width=160   160w,
                ${variantImageUrl}?width=180   180w,
                ${variantImageUrl}?width=220   220w,
                ${variantImageUrl}?width=254   254w,
                ${variantImageUrl}?width=284   284w,
                ${variantImageUrl}?width=292   292w,
                ${variantImageUrl}?width=320   320w,
                ${variantImageUrl}?width=480   480w,
                ${variantImageUrl}?width=528   528w,
                ${variantImageUrl}?width=640   640w,
                ${variantImageUrl}?width=720   720w,
                ${variantImageUrl}?width=960   960w,
                ${variantImageUrl}?width=1080 1080w,
                ${variantImageUrl}?width=1200 1200w
              "
              sizes="(min-width: 1400px) calc((100vw - 288px) / 4), (min-width: 750px) calc((100vw - 258px) / 2), (min-width: 480px) calc(100vw / 2), calc(100vw / 2)"
              class=""
            />
          </figure>
        </div>
          
          `;
          })
          .join("")}

      </div>

      ${
        product?.images?.nodes?.length > 1
          ? `

        <hover-images class="product-item__bg__under">
         <div class="product-item__bg__slider" data-hover-slider="">
        ${product.images.nodes
          .map((image, productIndex) => {
            const cdnProductImageUrl = image.url;
            const productImageSlug = cdnProductImageUrl
              .split("/")
              [cdnProductImageUrl.split("/").length - 1].split("?")[0];
            const productImageUrl = `//www.hatcountry.com/cdn/shop/files/${productImageSlug}`;

            return `
          <div class="product-item__bg__slide" data-hover-slide-touch="" ${
            productIndex === 1 ? `data-hover-slide=''` : ""
          }>
            <figure
              class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill"
              style="--aspect-ratio: 1"
            >
              <img
                src="${productImageUrl}?crop=center"
                alt=""
               
                loading="lazy"
                srcset="
                ${productImageUrl}?width=136   136w,
                ${productImageUrl}?width=160   160w,
                ${productImageUrl}?width=180   180w,
                ${productImageUrl}?width=220   220w,
                ${productImageUrl}?width=254   254w,
                ${productImageUrl}?width=284   284w,
                ${productImageUrl}?width=292   292w,
                ${productImageUrl}?width=320   320w,
                ${productImageUrl}?width=480   480w,
                ${productImageUrl}?width=528   528w,
                ${productImageUrl}?width=640   640w,
                ${productImageUrl}?width=720   720w,
                ${productImageUrl}?width=960   960w,
                ${productImageUrl}?width=1080 1080w,
                ${productImageUrl}?width=1200 1200w
                "
                sizes="(min-width: 1400px) calc((100vw - 288px) / 4), (min-width: 750px) calc((100vw - 258px) / 2), (min-width: 480px) calc(100vw / 2), calc(100vw / 2)"
                class=""
              />
            </figure>
          </div>
          `;
          })
          .join("")}
        </div>
        </hover-images>
      
      `
          : ""
      }
       
        
      

      


      
      </a>
      ${QuickAddProduct(product, widgetSettings)}

      
  </div>
 `;
  }

  QuickAddProduct(product, widgetSettings) {
    if (
      product.variants.nodes.length === 1 &&
      !product.variants.nodes[0].availableForSale
    )
      return "";
    const productId = product.id.split("gid://shopify/Product/")[1];
    const variantId = product.variants.nodes[0].id
      .toLowerCase()
      .split("gid://shopify/productvariant/")[1];
    return `
  <quick-add-product>
      <div class="quick-add__holder" data-quick-add-holder=${productId}>
     
      <button
          class="quick-add__button caps"
          type="button"
          aria-label="Quick add"
          data-quick-add-btn=""
          data-quick-add-modal-handle=${product.handle}
          data-personalizerai-attribution-token=${
            widgetSettings.attributionToken
          }
          data-product-id=${productId}
        >
          <span class="btn__text">Quick add</span>
          <span class="btn__plus"></span>
          <span class="btn__added">&nbsp;</span>
          <span class="btn__loader">
            <svg height="18" width="18" class="svg-loader">
              <circle r="7" cx="9" cy="9"></circle>
              <circle
                stroke-dasharray="87.96459430051421 87.96459430051421"
                r="7"
                cx="9"
                cy="9"
              ></circle>
            </svg>
          </span>
        </button>
          

      <template data-quick-add-modal-template="">
          <dialog
            class="drawer product-quick-add"
            data-product-id=${product.id.split("gid://shopify/Product/")[1]}
            data-section-id=${widgetSettings.sectionId}
            inert=""
            data-quick-add-modal=""
            data-scroll-lock-required=""
          >
            <form method="dialog">
              <button class="visually-hidden no-js" aria-label="Close"></button>
            </form>

            <div
              class="drawer__inner product-quick-add__content"
              data-product-upsell-container=""
              data-scroll-lock-scrollable=""
              style="--swatch-size: var(--swatch-size-product)"
            >
              <div class="product-quick-add__close-outer">
                <button
                  class="product-quick-add__close drawer__close"
                  aria-label="Close"
                  data-quick-add-modal-close=""
                  autofocus=""
                >
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="presentation"
                    class="icon icon-cancel"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M6.758 17.243 12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </button>
              </div>

              <div
                class="product-quick-add__inner"
                data-product-upsell-ajax=""
              ></div>

              <div class="loader loader--top">
                <div class="loader-indeterminate"></div>
              </div>
            </div>
          </dialog>
      </template>
    </div>
  </quick-add-product>
  `;
  }
}

class PersonalizeraiTabbedCard {
  constructor() {
    this.widgets = [
      ...document.querySelectorAll("[data-personalizerai-widget-tabbed]"),
    ];
    if (this.widgets?.length) {
      this.renderWidgets();
    } else {
      console.info("No widget target found for Custom card to render");
    }
  }

  renderWidgets() {
    const wids = this.widgets;
    for (const widget of wids) {
      this.renderWidget(widget);
    }
  }

  async renderWidget(widget) {
    try {
      const widgetSettings = this.generateWidgetSettings(widget);
      const globalSettings = this.getGlobalSettings(widget);
      const predictions = await this.getPredictions(widget, widgetSettings);
      if (!predictions?.products?.length) return;

      let products = await this.getProducts(predictions, globalSettings);

      if (!products?.filter((p) => p)?.length) return;
      products = products?.filter((p) => p);

      widgetSettings.attributionToken = predictions.attributionToken;
      try {
        window.PersonalizerAI.sdk.sendWidgetViewEvent({
          products: products.map((prod) => ({
            productId: window.PersonalizerAI.sdk.removeGID(prod.id, "Product"),
            variantId: window.PersonalizerAI.sdk.removeGID(prod.id, "Product"),
            quantity: 1,
          })),
          attributionToken: predictions.attributionToken,
          settings: {
            modelId: widgetSettings.model,
            limit: widgetSettings.limit,
            widgetId: widgetSettings.sectionId,
          },
        });
      } catch (err) {
        console.error(err, "unable to send event");
      }
      if (widget.dataset?.isolatedSlider === "true") {
        widget.innerHTML = this.IsolatedSliderProducts(
          products,
          widgetSettings,
          globalSettings,
        );
      } else {
        widget.innerHTML = this.Products(
          products,
          widgetSettings,
          globalSettings,
        );
      }

      // ! attribution token for gridswatches;
      // @ts-ignore
      this.gridSwatchAttributionTokenInjector(widget);
      // quick add button attribution token injector
      // @ts-ignore
      __personalizeraiOnRecommendationAddSetAttributionTokenDataOnDialog(
        ".personalizerai__widget__tabbed_custom_card .quick-add__holder .quick-add__button",
      );

      const slider = widget.querySelector(`.product-grid-swiper`);

      if (!slider) {
        return;
      }

      // @ts-ignore
      const swiper = new Swiper(slider, {
        on: {
          init: function () {
            slider.classList.remove("personalizerai-widget--hidden");
          },
        },
        slidesPerView: 2.35,
        slidesPerGroup: 2,
        spaceBetween: 30,
        loop: false,
        speed: 600,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          499: {
            slidesPerView: 2.2,
            slidesPerGroup: 2,
            spaceBetween: 10,
          },
          767: {
            slidesPerView: 3.15,
            slidesPerGroup: 3,
            spaceBetween: 24,
          },
          1100: {
            slidesPerView: 6,
            slidesPerGroup: 6,
            spaceBetween: 24,
          },
        },
      });
    } catch (err) {
      console.error(err);
      widget.innerHTML = "";
    }
  }

  // ui elements

  IsolatedSliderProducts(products, widgetSettings, globalSettings) {
    const ProductCardWidget = this.ProductCard.bind(this);
    return /* HTML */ `
      <div
        id="isolated-product-slider--${widgetSettings.sectionId}"
        class="personalizerai-product-recommendations"
      >
        <div class="grid-container">
          <div class="grid__heading-holder text-center wrapper--full-padded">
            <div class="grid__heading-text">
              <h2
                class="grid__heading heading-medium aos-animate"
                data-aos="hero"
                data-aos-anchor="#isolated-product-slider--${widgetSettings.sectionId}"
                data-aos-order="1"
              >
                ${widgetSettings?.heading ||
                widgetSettings?.block_heading ||
                ""}
              </h2>
            </div>
          </div>

          <div class="grid__items-holder">
            <div class="grid-outer">
              <grid-slider align-arrows>
                <div
                  class="grid grid--slider grid--mobile-slider is-enabled"
                  data-grid-slider
                  id="__scrollBeeProductContainerElement"
                >
                  ${products
                    .map((product) =>
                      ProductCardWidget(
                        product,
                        widgetSettings,
                        globalSettings,
                        true,
                      ),
                    )
                    .join("")}
                </div>
                <div class="slider__arrows">
                  <button
                    type="button"
                    class="slider__button slider__button--prev"
                    data-button-arrow=""
                    data-button-prev=""
                  >
                    Previous</button
                  ><button
                    type="button"
                    class="slider__button slider__button--next"
                    data-button-arrow=""
                    data-button-next=""
                  >
                    Next
                  </button>
                </div>
              </grid-slider>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  Products(products, widgetSettings, globalSettings) {
    const ProductCardWidget = this.ProductCard.bind(this);
    return /* HTML */ `
      <div
        class="personalizerai-product-recommendations ${widgetSettings.widgetType ===
        "product-tab"
          ? "product-tabs-list-main-section"
          : ""}"
      >
        <div
          id="product-grid-swiper--${widgetSettings.sectionId}"
          class="swiper product-grid-swiper product-grid personalizerai-widget--hidden"
        >
          <div class="swiper-wrapper">
            ${products
              .map((product) =>
                ProductCardWidget(product, widgetSettings, globalSettings),
              )
              .join("")}
          </div>

          <div
            class="swiper-button-next"
            tabindex="-1"
            role="button"
            aria-label="Next slide"
            aria-disabled="true"
            data-scrollbar-arrow-next
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
            >
              <path
                d="M12.9038 7.3463C12.8209 7.26906 12.7544 7.17591 12.7083 7.07241C12.6621 6.96891 12.6373 6.85718 12.6353 6.74389C12.6333 6.6306 12.6542 6.51807 12.6966 6.41301C12.7391 6.30794 12.8022 6.21251 12.8823 6.13238C12.9625 6.05226 13.0579 5.9891 13.163 5.94666C13.268 5.90423 13.3806 5.88339 13.4938 5.88539C13.6071 5.88739 13.7189 5.91218 13.8224 5.9583C13.9259 6.00441 14.019 6.0709 14.0963 6.1538L25.3463 17.4038C25.5043 17.562 25.593 17.7765 25.593 18.0001C25.593 18.2236 25.5043 18.4381 25.3463 18.5963L14.0963 29.8463C13.9363 29.9953 13.7248 30.0765 13.5062 30.0726C13.2876 30.0688 13.079 29.9802 12.9244 29.8256C12.7698 29.671 12.6813 29.4625 12.6774 29.2439C12.6736 29.0253 12.7547 28.8137 12.9038 28.6538L23.5561 18.0001L12.9038 7.3463Z"
                fill="black"
              ></path>
            </svg>
          </div>

          <div
            class="swiper-button-prev"
            tabindex="-1"
            role="button"
            aria-label="Previous slide"
            aria-disabled="true"
            data-scrollbar-arrow-next
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
            >
              <path
                d="M23.0962 28.6537C23.1791 28.7309 23.2456 28.8241 23.2917 28.9276C23.3379 29.0311 23.3627 29.1428 23.3647 29.2561C23.3667 29.3694 23.3458 29.4819 23.3034 29.587C23.2609 29.6921 23.1978 29.7875 23.1177 29.8676C23.0375 29.9477 22.9421 30.0109 22.837 30.0533C22.732 30.0958 22.6194 30.1166 22.5062 30.1146C22.3929 30.1126 22.2811 30.0878 22.1776 30.0417C22.0741 29.9956 21.981 29.9291 21.9037 29.8462L10.6537 18.5962C10.4957 18.438 10.407 18.2235 10.407 17.9999C10.407 17.7764 10.4957 17.5619 10.6537 17.4037L21.9037 6.1537C22.0637 6.00466 22.2752 5.92352 22.4938 5.92738C22.7124 5.93123 22.921 6.01979 23.0756 6.17437C23.2302 6.32896 23.3187 6.53752 23.3226 6.75611C23.3264 6.9747 23.2453 7.18625 23.0962 7.3462L12.4439 17.9999L23.0962 28.6537Z"
                fill="black"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    `;
  }

  ProductCard(product, widgetSettings, globalSettings, isolatedSlider = false) {
    const Product = this.Product.bind(this);
    if (isolatedSlider) {
      return /* HTML */ Product(product, widgetSettings, globalSettings);
    } else {
      return /* HTML */ `<div class="swiper-slide products-grid-tab-collection">
        ${Product(product, widgetSettings, globalSettings)}
      </div>`;
    }
  }

  Product(product, widgetSettings, globalSettings) {
    const ProductImage = this.ProductImage.bind(this);
    const ProductInformation = this.ProductInformation.bind(this);

    return /* HTML */ ` <grid-item
      class="grid-item product-item product-item--swatches product-item--centered product-item--outer-text product-item--has-quickbuy "
      id="product-item--${widgetSettings.sectionId}-${product.id.split(
        "gid://shopify/Product/",
      )[1]}"
      data-grid-item
      data-url="${product.productUrl}"
      data-swap-id="true"
    >
      ${ProductImage(product, widgetSettings)}
      ${ProductInformation(product, widgetSettings, globalSettings)}
    </grid-item>`;
  }

  ProductInformation(product, widgetSettings, globalSettings) {
    const QuickAddProduct = this.QuickAddProduct.bind(this);
    const productURL = `${product.onlineStoreUrl}?personalizerai_attr_token=${widgetSettings.attributionToken}`;
    const colorVariants = {};
    const colorOptions = product.options.find(
      (option) => option.name === "Color" && option.values.length >= 1,
    );

    if (colorOptions) {
      colorOptions.values.forEach((value) => {
        const variant = product.variants.nodes.find((variant) =>
          variant.title.includes(value),
        );
        if (variant) {
          colorVariants[value] = variant;
        }
      });
    }
    // ? quick add at the bottom if you want mobile widget (only works for update theme)
    //   ${QuickAddProduct(product, widgetSettings, "mobile")}

    return /* HTML */ `
      <div
        class="product-information"
        style="--swatch-size: var(--swatch-size-filters)"
        data-product-information=""
      >
        <div class="product-item__info body-medium">
          <a
            class="product-link"
            href=${productURL}
            data-product-link=${productURL}
          >
            <p class="product-item__title">${product.title}</p>
          </a>

          <div
            class="product-item__swatches__holder product-item__swatches__holder--square product-item__swatches__holder--text-slider"
          >
            <form
              class="radio__fieldset radio__fieldset--swatches radio__fieldset--pgi"
              data-grid-swatch-form=""
              data-fieldset=""
            >
              ${colorOptions
                ? /* HTML */ `
                    <grid-swatch
                      class="selector-wrapper__scrollbar"
                      data-scrollbar=""
                      data-personalizerai-attribution-token="${widgetSettings.attributionToken}"
                      data-swatch-handle=${product.handle}
                      data-swatch-label="Color"
                      data-swatch-values="${colorOptions.values
                        .map(
                          (key) =>
                            `${key}:${key.toLowerCase().replaceAll(" ", "-")}`,
                        )
                        .join(",")}"
                    >
                    </grid-swatch>
                  `
                : ""}
            </form>
            ${colorOptions?.values?.length
              ? /* HTML */ `
                  <span class="product-item__swatches__count">
                    <span data-swatch-count=""
                      >${colorOptions.values.length} colors</span
                    >
                  </span>
                `
              : ``}

            <div class="selector-wrapper__actions">
              <button
                type="button"
                class="radio__fieldset__arrow radio__fieldset__arrow--prev is-hidden"
                data-scrollbar-arrow-prev=""
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  role="presentation"
                  class="icon icon-nav-arrow-left"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m15 6-6 6 6 6"
                    stroke="#000"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span class="visually-hidden">See All</span>
              </button>
              <button
                type="button"
                class="radio__fieldset__arrow radio__fieldset__arrow--next is-hidden"
                data-scrollbar-arrow-next=""
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  role="presentation"
                  class="icon icon-nav-arrow-right"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m9 6 6 6-6 6"
                    stroke="#000"
                    stroke-width="1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
                <span class="visually-hidden">See All</span>
              </button>
            </div>
          </div>

          <div class="product-item__price">
            <span class="price sale">
              <span class="new-price trans-money-done"
                >${product.displayPrice.price}</span
              >

              ${product?.displayPrice?.compareAtPrice
                ? /* HTML */ `
                    <span class="old-price"
                      >${product.displayPrice.compareAtPrice}</span
                    >
                  `
                : ""}
            </span>
          </div>
        </div>
      </div>
    `;
  }

  ProductImage(product, widgetSettings) {
    const OldQuickAddProduct = this.OldQuickAddProduct.bind(this);
    const productURL = `${product.onlineStoreUrl}?personalizerai_attr_token=${widgetSettings.attributionToken}`;
    const shopifyCdnImageUrl = product?.images?.nodes?.[0]?.url;
    const imageSlug = shopifyCdnImageUrl
      ? shopifyCdnImageUrl
          .split("/")
          [shopifyCdnImageUrl.split("/").length - 1].split("?")[0]
      : null;
    const imageUrl = imageSlug
      ? `//www.hatcountry.com/cdn/shop/files/${imageSlug}`
      : null;
    const colorOptions = product.options.find(
      (option) => option.name === "Color" && option.values.length >= 1,
    );
    const colorVariants = {};

    if (colorOptions) {
      colorOptions.values.forEach((value) => {
        const variant = product.variants.nodes.find((variant) => {
          return variant?.selectedOptions?.find(
            (option) => option.name === "Color" && option.value === value,
          );
        });
        if (variant) {
          colorVariants[value] = variant;
        }
      });
    }

    return /* HTML */ `
      <div
        class="product-item__image ${product?.images?.nodes?.length > 1
          ? "double__image"
          : ""}"
        data-product-image=""
      >
        <a
          class="product-link"
          href="${productURL}"
          aria-label="${product.title}"
          data-product-link="${productURL}"
        >
          <div class="product-item__bg" data-product-image-default="">
            <figure
              class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill aos-animate"
              style="--aspect-ratio: 1;"
              data-aos="img-in"
              data-aos-delay="50"
              data-aos-duration="800"
              data-aos-anchor="#product-item--${widgetSettings.sectionId}-${product.id.split(
                "gid://shopify/Product/",
              )[1]}"
              data-aos-easing="ease-out-quart"
              data-asw-orgbgnotimg="none"
            >
              ${imageUrl
                ? `<img
                src=${imageUrl}
                alt=${product.images.nodes[0]?.altText || ""}
                loading="eager"
                srcset="
                  ${imageUrl}?width=136    136w,
                  ${imageUrl}?width=160    160w,
                  ${imageUrl}?width=180   180w,
                  ${imageUrl}?width=220   220w,
                  ${imageUrl}?width=254   254w,
                  ${imageUrl}?width=284   284w,
                  ${imageUrl}?width=292   292w,
                  ${imageUrl}?width=320   320w,
                  ${imageUrl}?width=480   480w,
                  ${imageUrl}?width=528   528w,
                  ${imageUrl}?width=640   640w,
                  ${imageUrl}?width=720   720w,
                  ${imageUrl}?width=960   960w,
                  ${imageUrl}?width=1080 1080w,
                  ${imageUrl}?width=1200 1200w
                "
                sizes="(min-width: 1400px) calc((100vw - 288px) / 4), (min-width: 750px) calc((100vw - 258px) / 2), (min-width: 480px) calc(100vw / 2), calc(100vw / 2)"
                fetchpriority="high"
                class=""
                data-asw-orgbgnotimg="none"
                style="font-size: 19.2px !important;"
              />`
                : ""}
            </figure>

            ${Object.values(colorVariants)
              .map((variant) => {
                const cdnVariantImageUrl = variant?.image?.url || "";
                const variantImageSlug = cdnVariantImageUrl
                  ?.split("/")
                  [cdnVariantImageUrl.split("/").length - 1]?.split("?")?.[0];
                const variantImageUrl = variantImageSlug
                  ? `//www.hatcountry.com/cdn/shop/files/${variantImageSlug}`
                  : "";
                return /* HTML */ `
                  <div
                    class="product-item__bg__inner"
                    data-variant-title="${variant.title}"
                  >
                    <figure
                      class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill"
                      style="--aspect-ratio: 1"
                    >
                      <img
                        src="${variantImageUrl}?crop=center"
                        alt=${variant.image?.altText || ""}
                        loading="lazy"
                        srcset="
                          ${variantImageUrl}?width=136    136w,
                          ${variantImageUrl}?width=160    160w,
                          ${variantImageUrl}?width=180    180w,
                          ${variantImageUrl}?width=220    220w,
                          ${variantImageUrl}?width=254    254w,
                          ${variantImageUrl}?width=284    284w,
                          ${variantImageUrl}?width=292    292w,
                          ${variantImageUrl}?width=320   320w,
                          ${variantImageUrl}?width=480   480w,
                          ${variantImageUrl}?width=528   528w,
                          ${variantImageUrl}?width=640   640w,
                          ${variantImageUrl}?width=720   720w,
                          ${variantImageUrl}?width=960   960w,
                          ${variantImageUrl}?width=1080 1080w,
                          ${variantImageUrl}?width=1200 1200w
                        "
                        sizes="(min-width: 1400px) calc((100vw - 288px) / 4), (min-width: 750px) calc((100vw - 258px) / 2), (min-width: 480px) calc(100vw / 2), calc(100vw / 2)"
                        class=""
                      />
                    </figure>
                  </div>
                `;
              })
              .join("")}
          </div>

          ${product?.images?.nodes?.length > 1
            ? /* HTML */ `
                <hover-images class="product-item__bg__under">
                  <div class="product-item__bg__slider" data-hover-slider="">
                    ${product.images.nodes
                      .map((image, productIndex) => {
                        const cdnProductImageUrl = image.url;
                        const productImageSlug = cdnProductImageUrl
                          .split("/")
                          [
                            cdnProductImageUrl.split("/").length - 1
                          ].split("?")[0];
                        const productImageUrl = `//www.hatcountry.com/cdn/shop/files/${productImageSlug}`;

                        return /* HTML */ `
                          <div
                            class="product-item__bg__slide"
                            data-hover-slide-touch=""
                            ${productIndex === 1 ? `data-hover-slide=''` : ""}
                          >
                            <figure
                              class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill"
                              style="--aspect-ratio: 1"
                            >
                              <img
                                src="${productImageUrl}?crop=center"
                                alt=""
                                loading="lazy"
                                srcset="
                                  ${productImageUrl}?width=136    136w,
                                  ${productImageUrl}?width=160    160w,
                                  ${productImageUrl}?width=180    180w,
                                  ${productImageUrl}?width=220    220w,
                                  ${productImageUrl}?width=254    254w,
                                  ${productImageUrl}?width=284    284w,
                                  ${productImageUrl}?width=292    292w,
                                  ${productImageUrl}?width=320    320w,
                                  ${productImageUrl}?width=480   480w,
                                  ${productImageUrl}?width=528   528w,
                                  ${productImageUrl}?width=640   640w,
                                  ${productImageUrl}?width=720   720w,
                                  ${productImageUrl}?width=960   960w,
                                  ${productImageUrl}?width=1080 1080w,
                                  ${productImageUrl}?width=1200 1200w
                                "
                                sizes="(min-width: 1400px) calc((100vw - 288px) / 4), (min-width: 750px) calc((100vw - 258px) / 2), (min-width: 480px) calc(100vw / 2), calc(100vw / 2)"
                                class=""
                              />
                            </figure>
                          </div>
                        `;
                      })
                      .join("")}
                  </div>
                </hover-images>
              `
            : ""}
        </a>
        ${OldQuickAddProduct(product, widgetSettings)}
      </div>
    `;
  }

  QuickAddProduct(product, widgetSettings, type = "desktop") {
    if (
      product.variants.nodes.length === 1 &&
      !product.variants.nodes[0].availableForSale
    )
      return "";
    const productId = product.id.split("gid://shopify/Product/")[1];
    const variantId = product.variants.nodes[0].id
      .toLowerCase()
      .split("gid://shopify/productvariant/")[1];
    return /* HTML */ `
      <quick-add-product>
        <div
          class="quick-add__holder ${type}"
          data-quick-add-holder=${productId}
        >
          <button
            class="quick-add__button btn btn--solid btn--small"
            type="button"
            aria-label="Quick add"
            data-quick-add-btn=""
            data-quick-add-modal-handle=${product.handle}
            data-personalizerai-attribution-token=${widgetSettings.attributionToken}
            data-product-id=${productId}
          >
            <span class="btn__text">Add to cart</span>
            <span class="btn__added">&nbsp;</span>
            <span class="btn__loader">
              <svg height="18" width="18" class="svg-loader">
                <circle r="7" cx="9" cy="9"></circle>
                <circle
                  stroke-dasharray="87.96459430051421 87.96459430051421"
                  r="7"
                  cx="9"
                  cy="9"
                ></circle>
              </svg>
            </span>
            <span class="btn__error" data-message-error="">&nbsp;</span>
          </button>

          <template data-quick-add-modal-template="">
            <dialog
              class="drawer product-quick-add"
              data-product-id=${product.id.split("gid://shopify/Product/")[1]}
              data-section-id=${widgetSettings.sectionId}
              inert=""
              data-quick-add-modal=""
              data-scroll-lock-required=""
            >
              <form method="dialog">
                <button
                  class="visually-hidden no-js"
                  aria-label="Close"
                ></button>
              </form>

              <div
                class="drawer__inner product-quick-add__content"
                data-product-upsell-container=""
                data-scroll-lock-scrollable=""
                style="--swatch-size: var(--swatch-size-product)"
              >
                <div class="product-quick-add__close-outer">
                  <button
                    class="product-quick-add__close drawer__close"
                    aria-label="Close"
                    data-quick-add-modal-close=""
                    autofocus=""
                  >
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      class="icon icon-cancel"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M6.758 17.243 12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </button>
                </div>

                <div
                  class="product-quick-add__inner"
                  data-product-upsell-ajax=""
                ></div>

                <div class="loader loader--top">
                  <div class="loader-indeterminate"></div>
                </div>
              </div>
            </dialog>
          </template>
        </div>
      </quick-add-product>
    `;
  }

  OldQuickAddProduct(product, widgetSettings) {
    if (
      product.variants.nodes.length === 1 &&
      !product.variants.nodes[0].availableForSale
    )
      return "";
    const productId = product.id.split("gid://shopify/Product/")[1];
    const variantId = product.variants.nodes[0].id
      .toLowerCase()
      .split("gid://shopify/productvariant/")[1];
    return `
  <quick-add-product>
      <div class="quick-add__holder" data-quick-add-holder=${productId}>
     
      <button
          class="quick-add__button caps"
          type="button"
          aria-label="Quick add"
          data-quick-add-btn=""
          data-quick-add-modal-handle=${product.handle}
          data-personalizerai-attribution-token=${
            widgetSettings.attributionToken
          }
          data-product-id=${productId}
        >
          <span class="btn__text">Quick add</span>
          <span class="btn__plus"></span>
          <span class="btn__added">&nbsp;</span>
          <span class="btn__loader">
            <svg height="18" width="18" class="svg-loader">
              <circle r="7" cx="9" cy="9"></circle>
              <circle
                stroke-dasharray="87.96459430051421 87.96459430051421"
                r="7"
                cx="9"
                cy="9"
              ></circle>
            </svg>
          </span>
        </button>
          

      <template data-quick-add-modal-template="">
          <dialog
            class="drawer product-quick-add"
            data-product-id=${product.id.split("gid://shopify/Product/")[1]}
            data-section-id=${widgetSettings.sectionId}
            inert=""
            data-quick-add-modal=""
            data-scroll-lock-required=""
          >
            <form method="dialog">
              <button class="visually-hidden no-js" aria-label="Close"></button>
            </form>

            <div
              class="drawer__inner product-quick-add__content"
              data-product-upsell-container=""
              data-scroll-lock-scrollable=""
              style="--swatch-size: var(--swatch-size-product)"
            >
              <div class="product-quick-add__close-outer">
                <button
                  class="product-quick-add__close drawer__close"
                  aria-label="Close"
                  data-quick-add-modal-close=""
                  autofocus=""
                >
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="presentation"
                    class="icon icon-cancel"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M6.758 17.243 12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </button>
              </div>

              <div
                class="product-quick-add__inner"
                data-product-upsell-ajax=""
              ></div>

              <div class="loader loader--top">
                <div class="loader-indeterminate"></div>
              </div>
            </div>
          </dialog>
      </template>
    </div>
  </quick-add-product>
  `;
  }

  generateWidgetSettings(widget) {
    const settings = JSON.parse(widget.dataset?.settings || "{}");
    return {
      ...JSON.parse(widget?.dataset?.settings || "{}"),
      limit: widget.dataset?.limit || settings?.limit || 4,
      model: widget.dataset?.model || settings?.model || "latest",
      block_heading: widget?.dataset?.blockHeading || null,
      sectionId: widget?.dataset?.sectionId || window.crypto.randomUUID(),
      widgetType: widget.dataset.widgetType || "product-tab",
    };
  }

  getGlobalSettings(widget) {
    return {
      ...JSON.parse(widget?.dataset?.shopSettings || "{}"),
    };
  }

  async getPredictions(widget, widgetSettings) {
    const settings = {
      shop: window.PersonalizerAI.shop,
      modelId: widgetSettings?.model || "recently_viewed",
      limit: widgetSettings?.limit || 4,
      dummy: window?.Shopify?.designMode ?? false,
      template: window.PersonalizerAI.trackingData.templateName,
      widgetType: "card",
    };

    const prediction = await window.PersonalizerAI.sdk.fetchPredictions({
      shop: settings.shop,
      modelId: settings.modelId,
      limit: settings.limit,
      test: settings.dummy,
      meta: {},
      blockId: widgetSettings.sectionId,
    });

    return prediction;
  }

  async getProducts(prediction, globalSettings) {
    const products = await window.PersonalizerAI.sdk.fetchProducts([
      ...prediction?.products,
      //   "gid://shopify/Product/9451787649330",
      //   "gid://shopify/Product/9451828609330",
      //   "gid://shopify/Product/9451807637810",
    ]);

    let mutatedProducts = products.map((product) => {
      let displayPrice = window.PersonalizerAI.sdk.getDisplayPrice(product);
      const productUrl = `${
        product.onlineStoreUrl?.split("?")[0]
      }?personalizerai_attr_token=${prediction.attributionToken}`;
      const colorOptions = product.options.find(
        (option) => option.name === "Color" && option.values.length >= 1,
      );
      const attributionToken = prediction.attributionToken;
      const productId = product.id.split("gid://shopify/Product/")[1];

      const colorVariants = {};

      if (colorOptions) {
        colorOptions.values.forEach((value) => {
          const variant = product.variants.nodes.find((variant) =>
            variant.title.includes(value),
          );

          const colorMapStrings =
            globalSettings?.swatch_color_list?.split(/\r?\n/);

          const colorMap = colorMapStrings.find((colorMapString) => {
            const colorMap = colorMapString.split(":");
            if (value === colorMap[0].trim()) {
              return true;
            }
            return false;
          });

          if (variant) {
            colorVariants[value] = {
              ...variant,
              colorValue: colorMap ? colorMap.split(":")[1].trim() : "",
            };
          }
        });
      }

      return {
        ...product,
        displayPrice,
        productUrl,
        colorOptions,
        attributionToken,
        colorVariants,
        productId,
      };
    });

    return mutatedProducts;
  }

  async gridSwatchAttributionTokenInjector(widget) {
    const widgets = [...widget.querySelectorAll("grid-swatch")];

    if (!widgets.length) return;

    const observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (
          mutation.target.nodeName === "GRID-SWATCH" &&
          mutation.addedNodes.length
        ) {
          console.log(mutation.target);
          const attributionToken =
            mutation?.target?.dataset?.personalizeraiAttributionToken;

          if (!attributionToken) return;
          const anchors = [...mutation.target.querySelectorAll("a")];
          anchors.forEach((a) => {
            const searchParam = new URLSearchParams(a.href.split("?")[1]);
            if (searchParam.get("personalizerai_attr_token")) return;

            searchParam.append("personalizerai_attr_token", attributionToken);
            a.href = `${a.href.split("?")[0]}?${searchParam.toString()}`;
          });
        }
      }
    });

    widgets.forEach((widget) => {
      observer.observe(widget, { childList: true });
    });
  }
}








function getQuickAddProductCard(product, attributionToken, analyticsTag) {
  const productId = product.id.split("gid://shopify/Product/")[1] ?? "";
  const productHandle = product?.handle ?? "";
  const productUrl = `/products/${productHandle}?personalizerai_attr_token=${attributionToken}`;
  const shopifyCdnImageUrl = product.images.nodes[0].url;
  const imageSlug = shopifyCdnImageUrl
    .split("/")
    [shopifyCdnImageUrl.split("/").length - 1].split("?")[0];
  const imageUrl = `//www.hatcountry.com/cdn/shop/files/${imageSlug}`;

  return `
      <quick-add-product>
        <div
          class="product-upsell__holder product-upsell__holder--button"
          data-quick-add-holder=${productId}
        >
          <div
            data-cart-errors-container=""
            class="product-upsell__errors"
          ></div>

          <div class="product-upsell">
            <div class="product-upsell__image">
              <a
                href=${productUrl}
                class="product-upsell__image__link"
                aria-label=${product.title}
              >
                <div class="product-upsell__image__thumb">
                  <figure
                    class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill"
                    style="--aspect-ratio: 0.7"
                  >
                    <img
                      src="${imageUrl}?crop=center&height=342&v=1723661418&width=240"
                      alt="${product.title}"
                      width="240"
                      height="342"
                      loading="eager"
                      srcset="
                  ${imageUrl}?width=120 120w,
                  ${imageUrl}?width=180 180w,
                  ${imageUrl}?width=240 240w,
                  ${imageUrl}?width=300 300w,
                  ${imageUrl}?width=360 360w,
                  ${imageUrl}?width=840 840w
                "
                       sizes="120px"
                      class=""
                    />
                  </figure>
                </div>
              </a>
            </div>

            <div class="product-upsell__content">
              <a href=${productUrl} class="product-upsell__link">
                <p class="product-upsell__title h3">${product.title}</p>
                <p class="product-upsell__price">
                  <span class="new-price"
                    >${window.PersonalizerAI.sdk.formatCurrency(
                      product.priceRange.minVariantPrice
                    )}</span
                  >
                </p>
              </a>
              <div class="product-upsell__actions">
                <div class="btn__outer">
                  <button
                    class="product-upsell__btn"
                    type="button"
                    data-quick-add-btn=""
                    data-personalizerai-attribution-token="${attributionToken}"
                    data-product-id="${productId}"
                    data-quick-add-modal-handle=${productHandle}
                  >
                    <span class="btn__plus"></span>
                    <span class="btn__text">Add</span>

                    <span class="btn__loader">
                      <svg height="18" width="18" class="svg-loader">
                        <circle r="7" cx="9" cy="9"></circle>
                        <circle
                          stroke-dasharray="87.96459430051421 87.96459430051421"
                          r="7"
                          cx="9"
                          cy="9"
                        ></circle>
                      </svg>
                    </span>

                    <span class="btn__added">&nbsp;</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <template data-quick-add-modal-template="">
            <dialog
              ${analyticsTag}='true'
              class="drawer product-quick-add"
              data-product-id="${productId}"
              data-section-id="${analyticsTag}"
              inert=""
              data-quick-add-modal=""
              data-scroll-lock-required=""
            >
              <form method="dialog">
                <button
                  class="visually-hidden no-js"
                  aria-label="Close"
                ></button>
              </form>

              <div
                class="drawer__inner product-quick-add__content"
                data-product-upsell-container=""
                data-scroll-lock-scrollable=""
                style="--swatch-size: var(--swatch-size-product)"
              >
                <div class="product-quick-add__close-outer">
                  <button
                    class="product-quick-add__close drawer__close"
                    aria-label="Close"
                    data-quick-add-modal-close=""
                    autofocus=""
                  >
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      class="icon icon-cancel"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M6.758 17.243 12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </button>
                </div>

                <div
                  class="product-quick-add__inner"
                  data-product-upsell-ajax=""
                ></div>

                <div class="loader loader--top">
                  <div class="loader-indeterminate"></div>
                </div>
              </div>
            </dialog>
          </template>
        </div>
        </quick-add-product>
      `;
}

 async function __personalizeraiOnRecommendationAddSetAttributionTokenDataOnDialog(
    buttonSelector
  ) {
    const btns = [...document.querySelectorAll(buttonSelector)];

    if (!btns.length) {
      console.info("No button found for attaching analytics");
      return;
    }

    for (const button of btns) {
      const attributionToken = button?.dataset?.personalizeraiAttributionToken;
      const productId = button?.dataset?.productId;
      if (!attributionToken || !productId) continue;

      button.addEventListener("click", (e) => {
        let buttonTimeout;
        const buttonWait = setInterval(() => {
          console.info("Finding Dialog Modal");

          const dialog = document.querySelector(
            `[data-quick-add-modal][data-product-id='${productId}']`
          );
          if (dialog) {
            console.info("Found Dialog Modal");
            clearInterval(buttonWait);
            clearTimeout(buttonTimeout);
            setAnalytics(dialog, attributionToken);
          }
        }, 10);

        buttonTimeout = setTimeout(() => {
          clearInterval(buttonWait);
          clearTimeout(buttonTimeout);
        }, 2000);
      });
    }

    function setAnalytics(node, attributionToken) {
      if (
        node.nodeName.toLowerCase() === "dialog" &&
        node?.dataset?.productId
      ) {
        const productId = node.dataset.productId;
        // removing attr token if present here before applying the new one
        removeAttributionTokenElement(node);
        const input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", "properties[_personalizerai]");
        input.setAttribute("value", attributionToken);

        node
          .querySelector(
            `[data-product-id='${node.dataset.productId}'] [data-form-wrapper]`
          )
          .insertAdjacentElement("beforeend", input);
        const productAnchor = node.querySelector(
          ".product-quick-add__form__inner .product__title a"
        );
        (
          node.querySelectorAll(
            'form[action="/cart/add"'
          ) 
        )?.forEach((ele) => {
          removeAttributionTokenElement(ele);
          console.log("found multiple action forms!!");
          ele.insertAdjacentElement("beforeend", input);
        });

        if (productAnchor?.href) {
          const searchParams = new URLSearchParams(
            productAnchor?.href?.split("?")[1] || ""
          );

          const url = productAnchor?.href?.split("?")[0] || "";
          searchParams.set("personalizerai_attr_token", attributionToken);
          if (!url) {
            productAnchor.href = "";
          }
          productAnchor.href = `${url}?${searchParams.toString()}`;
        }
      }
    }
  }

function __personalizeraiOnDialogCloseRemoveAttributionTokenData() {
  const target = document.body;
  if (!target) return;
  const config = { childList: true };

  new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      mutation.addedNodes?.forEach((node) => {
        if (node.nodeName.toLowerCase() === "dialog") {
          __remove(node);
        }
      });
    }
  }).observe(target, config);

  function __remove(node) {
    new MutationObserver((dialogMutationList, dialogObserver) => {
      for (const mutation of dialogMutationList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "open" &&
          mutation.target.getAttribute(mutation.attributeName) !== "true"
        ) {
          removeAttributionTokenElement(node);

          const productAnchor = node.querySelector(
            ".product-quick-add__form__inner .product__title a"
          );
          if (productAnchor?.href) {
            productAnchor.href = `/products${
              productAnchor.href.split("/products")[1].split("?")[0]
            }`;
          }
        }
      }
    }).observe(node, {
      attributes: true,
    });
  }
}

function removeAttributionTokenElement(node) {
  // add remove analytics function
  const attributionTokenInputs = node.querySelectorAll(
    "[name='properties[_personalizerai]']"
  );

  // removing multiple inputs now
  if (attributionTokenInputs.length) {
    console.log("found multiple inputs, removing them");
    attributionTokenInputs?.forEach((input) => input.remove());
    console.log("removed");
  }
}

// start

function personalizeraiGridSliderInit() {
  const selectors$Q = {
    buttonArrow: "[data-button-arrow]",
    collectionImage: "[data-collection-image]",
    columnImage: "[data-column-image]",
    productImage: "[data-product-image]",
    slide: "[data-grid-item]",
    slider: "[data-grid-slider]",
  };

  const classes$B = {
    arrows: "slider__arrows",
    visible: "is-visible",
    scrollSnapDisabled: "scroll-snap-disabled",
  };

  const classes$D = {
    visible: "is-visible",
  };

  const classes$C = {
    dragging: "is-dragging",
    enabled: "is-enabled",
    scrolling: "is-scrolling",
    visible: "is-visible",
  };

  const selectors$R = {
    image: "img, svg",
    productImage: "[data-product-image]",
    slide: "[data-grid-item]",
    slider: "[data-grid-slider]",
  };

  const attributes$v = {
    buttonPrev: "data-button-prev",
    buttonNext: "data-button-next",
    alignArrows: "align-arrows",
  };
  /*
      Trigger event after all animations complete in a specific section
    */
  function waitForAllAnimationsEnd(section) {
    return new Promise((resolve) => {
      const animatedElements = section.querySelectorAll("[data-aos]");
      let animationCount = 0;

      function onAnimationEnd(event) {
        animationCount++;

        if (animationCount === animatedElements.length) {
          // All animations have ended
          resolve();
        }

        event.target.removeEventListener("animationend", onAnimationEnd);
      }

      animatedElements.forEach((element) => {
        element.addEventListener("animationend", onAnimationEnd);
      });
    });
  }

  function isDesktop() {
    return getWindowWidth() >= window.theme.sizes.small;
  }

  function getWindowWidth() {
    return (
      document.documentElement.clientWidth ||
      document.body.clientWidth ||
      window.innerWidth
    );
  }

  class IsInView {
    constructor(container, itemSelector) {
      if (!container || !itemSelector) return;

      this.observer = null;
      this.container = container;
      this.itemSelector = itemSelector;

      this.init();
    }

    init() {
      const options = {
        root: this.container,
        threshold: [0.01, 0.5, 0.75, 0.99],
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.99) {
            entry.target.classList.add(classes$D.visible);
          } else {
            entry.target.classList.remove(classes$D.visible);
          }
        });
      }, options);

      this.container.querySelectorAll(this.itemSelector)?.forEach((item) => {
        this.observer.observe(item);
      });
    }

    destroy() {
      this.observer.disconnect();
    }
  }

  class DraggableSlider {
    constructor(sliderElement) {
      this.slider = sliderElement;
      this.isDown = false;
      this.startX = 0;
      this.scrollLeft = 0;
      this.velX = 0;
      this.scrollAnimation = null;
      this.isScrolling = false;
      this.duration = 800; // Change this value if you want to increase or decrease the velocity

      this.scrollStep = this.scrollStep.bind(this);
      this.scrollToSlide = this.scrollToSlide.bind(this);
      this.handleMouseDown = this.handleMouseDown.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.handleMouseUp = this.handleMouseUp.bind(this);
      this.handleMouseMove = this.handleMouseMove.bind(this);
      this.handleMouseWheel = this.handleMouseWheel.bind(this);

      this.slider.addEventListener("mousedown", this.handleMouseDown);
      this.slider.addEventListener("mouseleave", this.handleMouseLeave);
      this.slider.addEventListener("mouseup", this.handleMouseUp);
      this.slider.addEventListener("mousemove", this.handleMouseMove);
      this.slider.addEventListener("wheel", this.handleMouseWheel, {
        passive: true,
      });

      this.slider.classList.add(classes$C.enabled);
    }

    handleMouseDown(e) {
      e.preventDefault();
      this.isDown = true;
      this.startX = e.pageX - this.slider.offsetLeft;
      this.scrollLeft = this.slider.scrollLeft;
      this.cancelMomentumTracking();
    }

    handleMouseLeave() {
      if (!this.isDown) return;
      this.isDown = false;
      this.beginMomentumTracking();
    }

    handleMouseUp() {
      this.isDown = false;
      this.beginMomentumTracking();
    }

    handleMouseMove(e) {
      if (!this.isDown) return;
      e.preventDefault();

      const x = e.pageX - this.slider.offsetLeft;
      const ratio = 1; // Increase the number to make it scroll-fast
      const walk = (x - this.startX) * ratio;
      const prevScrollLeft = this.slider.scrollLeft;
      const direction = walk > 0 ? 1 : -1;

      this.slider.classList.add(classes$C.dragging, classes$C.scrolling);
      this.slider.scrollLeft = this.scrollLeft - walk;

      if (this.slider.scrollLeft !== prevScrollLeft) {
        this.velX = this.slider.scrollLeft - prevScrollLeft || direction;
      }
    }

    handleMouseWheel() {
      this.cancelMomentumTracking();
      this.slider.classList.remove(classes$C.scrolling);
    }

    beginMomentumTracking() {
      this.isScrolling = false;
      this.slider.classList.remove(classes$C.dragging);
      this.cancelMomentumTracking();
      this.scrollToSlide();
    }

    cancelMomentumTracking() {
      cancelAnimationFrame(this.scrollAnimation);
    }

    scrollToSlide() {
      if (!this.velX && !this.isScrolling) return;

      const slide = this.slider.querySelector(
        `${selectors$R.slide}.${classes$C.visible}`
      );
      if (!slide) return;

      const gap = parseInt(window.getComputedStyle(slide).marginRight) || 0;
      const slideWidth = slide.offsetWidth + gap;
      const targetPosition = slide.offsetLeft;
      const direction = this.velX > 0 ? 1 : -1;
      const slidesToScroll = Math.floor(Math.abs(this.velX) / 100) || 1;

      this.startPosition = this.slider.scrollLeft;
      this.distance = targetPosition - this.startPosition;
      this.startTime = performance.now();
      this.isScrolling = true;

      // Make sure it will move to the next slide if you don't drag far enough
      if (direction < 0 && this.velX < slideWidth) {
        this.distance -= slideWidth * slidesToScroll;
      }

      // Make sure it will move to the previous slide if you don't drag far enough
      if (direction > 0 && this.velX < slideWidth) {
        this.distance += slideWidth * slidesToScroll;
      }

      // Run scroll animation
      this.scrollAnimation = requestAnimationFrame(this.scrollStep);
    }

    scrollStep() {
      const currentTime = performance.now() - this.startTime;
      const scrollPosition = parseFloat(
        this.easeOutCubic(Math.min(currentTime, this.duration))
      ).toFixed(1);

      this.slider.scrollLeft = scrollPosition;

      if (currentTime < this.duration) {
        this.scrollAnimation = requestAnimationFrame(this.scrollStep);
      } else {
        this.slider.classList.remove(classes$C.scrolling);

        // Reset velocity
        this.velX = 0;
        this.isScrolling = false;
      }
    }

    easeOutCubic(t) {
      t /= this.duration;
      t--;
      return this.distance * (t * t * t + 1) + this.startPosition;
    }

    destroy() {
      this.slider.classList.remove(classes$C.enabled);
      this.slider.removeEventListener("mousedown", this.handleMouseDown);
      this.slider.removeEventListener("mouseleave", this.handleMouseLeave);
      this.slider.removeEventListener("mouseup", this.handleMouseUp);
      this.slider.removeEventListener("mousemove", this.handleMouseMove);
      this.slider.removeEventListener("wheel", this.handleMouseWheel);
    }
  }

  class PersonalizerAIGridSlider extends HTMLElement {
    constructor() {
      super();

      this.isInitialized = false;
      this.draggableSlider = null;
      this.positionArrows = this.positionArrows.bind(this);
      this.onButtonArrowClick = (e) => this.buttonArrowClickEvent(e);
      this.slidesObserver = null;
      this.firstLastSlidesObserver = null;
      this.isDragging = false;
      this.toggleSlider = this.toggleSlider.bind(this);
    }

    connectedCallback() {
      this.init();
      this.addEventListener("theme:grid-slider:init", this.init);
    }

    init() {
      this.slider = this.querySelector(selectors$Q.slider);
      this.slides = this.querySelectorAll(selectors$Q.slide);
      this.buttons = this.querySelectorAll(selectors$Q.buttonArrow);
      this.slider.classList.add(classes$B.scrollSnapDisabled);
      this.toggleSlider();
      document.addEventListener("theme:resize:width", this.toggleSlider);

      waitForAllAnimationsEnd(this).then(() => {
        this.slider.classList.remove(classes$B.scrollSnapDisabled);
      });
    }

    toggleSlider() {
      const sliderWidth = this.slider.clientWidth;
      const slidesWidth = this.getSlidesWidth();
      const isEnabled = sliderWidth < slidesWidth;

      if (isEnabled && (isDesktop() || !window.theme.touch)) {
        if (this.isInitialized) return;

        this.slidesObserver = new IsInView(this.slider, selectors$Q.slide);

        this.initArrows();
        this.isInitialized = true;

        // Create an instance of DraggableSlider
        this.draggableSlider = new DraggableSlider(this.slider);
      } else {
        this.destroy();
      }
    }

    initArrows() {
      // Create arrow buttons if don't exist
      if (!this.buttons.length) {
        const buttonsWrap = document.createElement("div");
        buttonsWrap.classList.add(classes$B.arrows);
        buttonsWrap.innerHTML =
          theme.sliderArrows.prev + theme.sliderArrows.next;

        // Append buttons outside the slider element
        this.append(buttonsWrap);
        this.buttons = this.querySelectorAll(selectors$Q.buttonArrow);
        this.buttonPrev = this.querySelector(`[${attributes$v.buttonPrev}]`);
        this.buttonNext = this.querySelector(`[${attributes$v.buttonNext}]`);
      }

      this.toggleArrowsObserver();

      if (this.hasAttribute(attributes$v.alignArrows)) {
        this.positionArrows();
        this.arrowsResizeObserver();
      }

      this.buttons.forEach((buttonArrow) => {
        buttonArrow.addEventListener("click", this.onButtonArrowClick);
      });
    }

    buttonArrowClickEvent(e) {
      e.preventDefault();

      const firstVisibleSlide = this.slider.querySelector(
        `${selectors$Q.slide}.${classes$B.visible}`
      );
      const numberOfSlidesInView = [
        ...this.slider.querySelectorAll(
          `${selectors$Q.slide}.${classes$B.visible}`
        ),
      ];
      let slide = null;

      if (e.target.hasAttribute(attributes$v.buttonPrev)) {
        if (this.slider?.dataset?.slidesToMove) {
          let __count = numberOfSlidesInView.length
            ? numberOfSlidesInView.length - 1
            : parseInt(this.slider?.dataset?.slidesToMove ?? "1");
          let __currentSlide = firstVisibleSlide;
          while (__count && __currentSlide?.previousElementSibling) {
            __currentSlide = __currentSlide?.previousElementSibling;
            __count--;
          }
          slide = __currentSlide;
        } else {
          slide = firstVisibleSlide?.previousElementSibling;
        }
      }

      if (e.target.hasAttribute(attributes$v.buttonNext)) {
        if (this.slider?.dataset?.slidesToMove) {
          let __count = numberOfSlidesInView.length
            ? numberOfSlidesInView.length - 1
            : parseInt(this.slider?.dataset?.slidesToMove ?? "1");
          let __currentSlide = firstVisibleSlide;
          while (__count && __currentSlide?.nextElementSibling) {
            __currentSlide = __currentSlide?.nextElementSibling;
            __count--;
          }
          slide = __currentSlide;
        } else {
          slide = firstVisibleSlide?.nextElementSibling;
        }
      }

      this.goToSlide(slide);
    }

    removeArrows() {
      this.querySelector(`.${classes$B.arrows}`)?.remove();
    }

    // Go to prev/next slide on arrow click
    goToSlide(slide) {
      if (!slide) return;

      this.slider.scrollTo({
        top: 0,
        left: slide.offsetLeft,
        behavior: "smooth",
      });
    }

    getSlidesWidth() {
      return (
        this.slider.querySelector(selectors$Q.slide)?.clientWidth *
        this.slider.querySelectorAll(selectors$Q.slide).length
      );
    }

    toggleArrowsObserver() {
      // Add disable class/attribute on prev/next button

      if (this.buttonPrev && this.buttonNext) {
        const slidesCount = this.slides.length;
        const firstSlide = this.slides[0];
        const lastSlide = this.slides[slidesCount - 1];

        const config = {
          attributes: true,
          childList: false,
          subtree: false,
        };

        const callback = (mutationList) => {
          for (const mutation of mutationList) {
            if (mutation.type === "attributes") {
              const slide = mutation.target;
              const isDisabled = Boolean(
                slide.classList.contains(classes$B.visible)
              );

              if (slide == firstSlide) {
                this.buttonPrev.disabled = isDisabled;
              }

              if (slide == lastSlide) {
                this.buttonNext.disabled = isDisabled;
              }
            }
          }
        };

        if (firstSlide && lastSlide) {
          this.firstLastSlidesObserver = new MutationObserver(callback);
          this.firstLastSlidesObserver.observe(firstSlide, config);
          this.firstLastSlidesObserver.observe(lastSlide, config);
        }
      }
    }

    positionArrows() {
      const targetElement =
        this.slider.querySelector(selectors$Q.productImage) ||
        this.slider.querySelector(selectors$Q.collectionImage) ||
        this.slider.querySelector(selectors$Q.columnImage) ||
        this.slider;

      if (!targetElement) return;

      this.style.setProperty(
        "--button-position",
        `${targetElement.clientHeight / 2}px`
      );
    }

    arrowsResizeObserver() {
      document.addEventListener("theme:resize:width", this.positionArrows);
    }

    disconnectedCallback() {
      this.destroy();
      document.removeEventListener("theme:resize:width", this.toggleSlider);
    }

    destroy() {
      this.isInitialized = false;
      this.draggableSlider?.destroy();
      this.draggableSlider = null;
      this.slidesObserver?.destroy();
      this.slidesObserver = null;
      this.removeArrows();

      document.removeEventListener("theme:resize:width", this.positionArrows);
    }
  }

  if (!customElements.get("pai-grid-slider")) {
    customElements.define("pai-grid-slider", PersonalizerAIGridSlider);
  }
}
